<template>
	<div>

		<breadcrumbs />
		<div class="content-i">
			<div class="content-box">
				<div class="row">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
                 				{{ t.navigation.markets }}
							</h6>
							<div class="element-box-tp">
                
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--------------------
START - Sidebar
-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>
				<div class="element-wrapper">
					<div class="element-actions actions-only" v-b-toggle.filter variant="primary">
							<span class="when-opened">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
							<span class="when-closed">
								<i class="os-icon os-icon-plus-circle"></i>
							</span>
					</div>
					<h6 class="element-header" v-b-toggle.filter variant="primary">
						{{ t.filter.title }}
					</h6>
					<div class="element-box-tp">
						<b-collapse id="filter" visible class="mt-2">

						</b-collapse>
					</div>
				</div>

			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>
	</div>
</template>

<script>
    import feed from "@/mixins/feed.js"
    export default {
        name: 'markets',
        mixins: [feed],
        data () {
            return {
                t: this.$root.t,
                markets: []
            }
        },
        mounted () {
          this.getMarkets()
        },
        methods: {
          getMarkets() {
            this.fetchTemplates().then(
              response => {
                this.markets = response.body
            })
          }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/feed/markets/markets.vue